import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const ListBrand = lazy(() => import("../../components/brand/listBrand"));

const ListBrandPage = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <ListBrand />
    </Suspense>
  );
};

export default ListBrandPage;
